import { supabase } from "../lib/supabase";

export async function ensureWalletExists(ownerUserId, ownerRole) {
  const { data, error } = await supabase.rpc("ensure_wallet_exists", {
    p_owner_user_id: ownerUserId,
    p_owner_role: ownerRole,
  });

  if (error) throw error;
  return data;
}

export async function creditPendingWallet({
  ownerUserId,
  ownerRole,
  amount,
  sourceType,
  sourceId,
  description,
}) {
  const { error } = await supabase.rpc("wallet_credit_pending", {
    p_owner_user_id: ownerUserId,
    p_owner_role: ownerRole,
    p_amount: amount,
    p_source_type: sourceType,
    p_source_id: sourceId,
    p_description: description || null,
  });

  if (error) throw error;
  return true;
}

export async function debitWallet({
  ownerUserId,
  ownerRole,
  amount,
  entryType,
  sourceType,
  sourceId,
  description,
}) {
  const { error } = await supabase.rpc("wallet_debit", {
    p_owner_user_id: ownerUserId,
    p_owner_role: ownerRole,
    p_amount: amount,
    p_entry_type: entryType,
    p_source_type: sourceType,
    p_source_id: sourceId,
    p_description: description || null,
  });

  if (error) throw error;
  return true;
}

export async function processWeeklySettlement(ownerRole) {
  const { error } = await supabase.rpc("run_weekly_settlement", {
    p_owner_role: ownerRole,
  });

  if (error) throw error;
  return true;
}

export async function fetchMyWallet(userId) {
  const { data, error } = await supabase
    .from("wallets")
    .select("*")
    .eq("owner_user_id", userId)
    .single();

  if (error && error.code !== "PGRST116") {
    throw error;
  }

  return data || null;
}

export async function fetchMyWalletLedger(userId) {
  const { data, error } = await supabase
    .from("wallet_ledger")
    .select("*")
    .eq("owner_user_id", userId)
    .order("created_at", { ascending: false })
    .limit(50);

  if (error) throw error;
  return data || [];
}

export async function savePayoutAccount(payload) {
  const { data: existing, error: existingError } = await supabase
    .from("payout_accounts")
    .select("id")
    .eq("owner_user_id", payload.owner_user_id)
    .eq("owner_role", payload.owner_role)
    .maybeSingle();

  if (existingError) throw existingError;

  if (existing?.id) {
    const { error } = await supabase
      .from("payout_accounts")
      .update(payload)
      .eq("id", existing.id);

    if (error) throw error;
    return true;
  }

  const { error } = await supabase.from("payout_accounts").insert(payload);
  if (error) throw error;

  return true;
}
